"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDeleteOfferItemErrorResponse = exports.Name = exports.DeleteOfferItemFailedEvent = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'delete-offer-item-failed';
const DeleteOfferItemFailedEvent = exports.DeleteOfferItemFailedEvent = Name;
const isDeleteOfferItemErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isDeleteOfferItemErrorResponse = isDeleteOfferItemErrorResponse;
